// MotionWrapper.jsx
import React from 'react';
import { motion } from 'framer-motion';

const MotionWrapperHeight = ({ children }) => {
    return (
        <motion.div
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: 'hidden' }}
        >
            {children}
        </motion.div>
    );
};

export default MotionWrapperHeight;
